import React from 'react';
import PropTypes from 'prop-types';
import { Number } from "../Inputs";

export default class BorderRadius extends React.Component
{
    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };

    render()
    {
        return <div className='flex items-center'>
            <div className='flex-1'>
                Border Radius
            </div>
            <Number
                style={{width: 76}}
                value={this.props.value}
                onChange={e => this.props.onChange(e.target.value)}
                onBlur={this.props.onBlur}
            />
        </div>;
    }
}
